"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("@jordibosch20/software_tools_package/dist/index");
var _material = require("@mui/material");
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function SortCentralWrapper(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    dataFromInput = _useState2[0],
    setDataFromChild = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    activeSelect = _useState4[0],
    setActiveSelect = _useState4[1];
  var _useState5 = (0, _react.useState)("a-z"),
    _useState6 = _slicedToArray(_useState5, 2),
    sortOrder = _useState6[0],
    setSortOrder = _useState6[1];
  var _useState7 = (0, _react.useState)("yes"),
    _useState8 = _slicedToArray(_useState7, 2),
    deleteDuplicates = _useState8[0],
    setDeleteDuplicates = _useState8[1];
  var handleDataFromInput = function handleDataFromInput(dataFromChild) {
    setDataFromChild(dataFromChild);
  };
  var handleChangeSortOrder = function handleChangeSortOrder(event) {
    setSortOrder(event.target.value);
  };
  var handleDeleteDuplicates = function handleDeleteDuplicates(event) {
    setDeleteDuplicates(event.target.value);
  };
  var handleActiveSelect = function handleActiveSelect(value) {
    setActiveSelect(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.CommonComponent, {
    sendDataToParent: handleActiveSelect,
    title: props.title,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
        variant: "standard",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel["default"], {
          id: "label-1",
          variant: "contained",
          children: "Sort order  : "
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select["default"], {
          labelId: "label-1",
          id: "demo-simple-select-standard",
          value: sortOrder,
          onChange: handleChangeSortOrder,
          label: "Sort order",
          className: "select",
          sx: {
            width: 200,
            // Smaller width
            fontSize: "0.875rem",
            // Smaller font size
            ".MuiSelect-select": {
              // Targeting the internal select element
              paddingTop: "3px",
              paddingBottom: "3px",
              fontSize: "12px"
            }
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
            value: "a-z",
            children: "A \u2192 Z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
            value: "z-a",
            children: "Z \u2192 A"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
        variant: "standard",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputLabel["default"], {
          id: "label-2",
          variant: "contained",
          htmlFor: "encoding-newline",
          children: ["Encode each new line separatedly:", " "]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select["default"], {
          labelId: "label-2",
          id: "demo-simple-select-standard",
          value: deleteDuplicates,
          onChange: handleDeleteDuplicates,
          className: "select",
          sx: {
            width: 200,
            // Smaller width
            fontSize: "0.875rem",
            // Smaller font size
            ".MuiSelect-select": {
              // Targeting the internal select element
              paddingTop: "3px",
              paddingBottom: "3px",
              fontSize: "12px"
            }
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
            value: "no",
            children: "Don't delete dups"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
            value: "yes",
            children: "Delete duplicates"
          })]
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.Input, {
        sendDataToParent: handleDataFromInput
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.Output, {
        activeSelect: activeSelect,
        f: props.f,
        input: dataFromInput,
        sortOrder: sortOrder,
        deleteDuplicates: deleteDuplicates
      })
    })]
  });
}
var _default = exports["default"] = SortCentralWrapper;